import { useState } from 'react';
import RateTrip from '../../components/ratingTrip/rateTrip';
import TitleBar from '../../components/titleBar/titleBar';
import { userUnAuthReview } from '../../api/userAPI';
import './rateTrip.css';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const Rating = () => {
    const { id, phone, type } = useParams();
    const [comment, setComment] = useState('');
    const [popupRating, setPopupRating] = useState(0);

    const handleSubmitRating = async (e) => {
        e.preventDefault();
        const data = {
            packId: id,
            phoneNumber: phone,
            comment,
            popupRating
        };
        try {
            const res = await userUnAuthReview(type, data);

            if (res?.response?.status === 200 || res?.status === 200) {
                toast.success('Rating submitted successfully!');
                setComment('');
                setPopupRating(0);
            } else {
                toast.error(res?.response?.data?.message || 'Something went wrong.');
            }
        } catch (error) {
            console.error('Error submitting rating:', error);
            toast.error(error?.response?.data?.message || 'An error occurred. Please try again.');
        }
    };

    return (
        <div className='tripRating'>
            <TitleBar title='Rate your trip' className='customTitle' />
            <div className='customContainer'>
                <RateTrip
                    props={{
                        popupRating,
                        setPopupRating,
                        comment,
                        setComment
                    }}
                />
                <button
                    onClick={(e) => {
                        handleSubmitRating(e);
                    }}
                >
                    Submit
                </button>
            </div>
        </div>
    );
};

export default Rating;
